import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';

@Injectable({
    providedIn: 'root'
})
export class TaxNumberTypesService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.TaxNumberTypes;
  jsonHeaders = { headers: { 'Content-Type': 'application/json' } }

  public GetAll(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetAll`);
  }

  public GetTaxNumberTypeByCountry(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/GetTaxNumberTypeByCountry`, dataId, this.jsonHeaders);
  }
}